import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTask = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.01 40.01",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		className: "cls-1",
		d: "M16.67 31a1.6 1.6 0 0 1-1.17-.49l-9.33-9.33a1.64 1.64 0 0 1 0-2.34l2.66-2.66a1.64 1.64 0 0 1 2.34 0l5.5 5.5L28.83 9.51a1.64 1.64 0 0 1 2.34 0l2.66 2.66a1.64 1.64 0 0 1 0 2.34l-16 16a1.6 1.6 0 0 1-1.16.49zM37.81 2.2a7.23 7.23 0 0 0-5.3-2.2H7.5a7.23 7.23 0 0 0-5.3 2.2A7.22 7.22 0 0 0 0 7.5v25a7.22 7.22 0 0 0 2.2 5.3A7.23 7.23 0 0 0 7.5 40h25a7.51 7.51 0 0 0 7.5-7.5v-25a7.23 7.23 0 0 0-2.19-5.3z"
	})
});
export default SvgIconTask;
